import React, { useState, useEffect, useCallback, memo } from 'react'
import { throttle } from 'lodash'
import { useHistory } from 'react-router-dom'
import { getAirportList } from '../_services/airport'
import moment from 'moment'
import useQuery from '../hooks/useQuery'
import { getFormattedDate } from '../utils/utility'
import { capitalizeEachWord } from '../_helper/header'

const bookingTypeList = ['All','Cold bed', 'Hot bed']
const today = new Date()

function _SearchTopBar({ setGlobalBookingType }) {
    const query = useQuery()
    const history = useHistory()
    const [iataRefreshKey, setIataRefreshKey] = useState(0)
    const [airportDetails, setAirportDetails] = useState({
        name: '',
        iata: '',
    })
    const url = new URL(window.location.href); // Get current URL
    const segments = url.pathname.split('/'); // Split path by "/"
    var locationCode = segments[segments.length - 1]; // Get last segment 
    
    if(locationCode == "property-listing" )
    {
        locationCode = null ;
    }
    
    const [airportCodeUrl, setAirportCodeUrl] = useState(locationCode)
   
    
    const [checkin, setCheckin] = useState(query.get('checkIn') || new Date().toISOString().split('T')[0])
    const [checkout, setCheckout] = useState(query.get('checkOut') || checkin)
    const [iataCode, setIataCode] = useState(query.get('iata')  ||   '')
    const [airportName, setAirportName] = useState(query.get('airportName') || '')
    const [airportlist, setAirportList] = useState([])
    const [propertyOption, setPropertyOption] = useState(false)
    const [bookingType, setBookingType] = useState(query.get('bookingType') || 'All')

    const fetchAirport = async (term) => {
        try {
            setAirportList([])
            getAirportList(
                term,
                (data) => {
                    setAirportList(data.airports)
                },
                (data) => {
                    setAirportList([])
                    setAirportDetails({ name: '' })
                }
            )
        } catch (error) {
            console.log('AirportCodeError', error)
            // toast.error(error.message,{toastId:100})
        }
    }

    const throtteledFetchAirport = useCallback(throttle(fetchAirport, 500), [])

    function handleAirportFetch(e) {
        setIataCode(e.target.value)
        throtteledFetchAirport(e.target.value)
    }

    function handleSearchProperty() {
        
        let params
        if (iataCode) {
            params = new URLSearchParams({
                iata: iataCode,
                airportName: airportDetails.name,
                bookingType,
                checkIn: checkin,
                checkOut: checkout,
            })
        } else
            params = new URLSearchParams({
                bookingType,
                checkIn: checkin,
                checkOut: checkout,
            })

        // history.push({
        //   pathname: `/property-listing?${params.toString()}`,
        //   state: {
        //     airportDetails,
        //   },
        // });
  //      window.location.href = `/property-listing?${params.toString()}`;
        if(iataCode)
        {
            window.location.href = `/property-listing/${iataCode}?${params.toString()}`;
        }
     
        else
        {
            window.location.href = `/property-listing?${params.toString()}`;
        }
        
       // history.push(`/property-listing?${params.toString()}`)
    }

    useEffect(() => {
        if (iataCode) {
            const airport = airportlist.find(curr => curr.iata === iataCode);
            if (airport) {
                setAirportName(airport.name);
            }
        }
        if (airportCodeUrl && !iataCode) {
            let params

            
            if (iataCode) {
                params = new URLSearchParams({
                    iata: iataCode,
                    airportName: airportDetails.name,
                    bookingType,
                    checkIn: checkin,
                    checkOut: checkout,
                })
                window.location.href = `/property-listing/${airportCodeUrl}?iata=${airportCodeUrl}&${params.toString()}`;
            } else
                params = new URLSearchParams({
                    bookingType,
                    checkIn: checkin,
                    checkOut: checkout,
                })
                if(airportCodeUrl)
                {
                    // getAirportList(
                    //     airportCodeUrl,
                    //     (data) => {
                    //         setAirportList(data.airports)
                    //     },
                    //     (data) => {
                    //         setAirportList([])
                    //         setAirportDetails({ name: '' })
                    //     }
                    // )
                    // console.log(airportlist , "data--list")
                    //window.location.href = `/property-listing/${airportCodeUrl}`;
                }
                else{
                    window.location.href = `/property-listing/${airportCodeUrl}?${params.toString()}`;
                }
            
            //     fetchAirport(airportCodeUrl)
            // console.log(airportlist);
            // alert("jj");
            // const airport = airportlist.find(curr => curr.iata === airportCodeUrl);
            // if (airport) {
            //     setAirportName(airport.name);
            // }
            //&airportname=${airport.name}
           // window.location.href = `/property-listing/${airportCodeUrl}?iata=${airportCodeUrl}&${params.toString()}`;
          
        }
        setCheckin(query.get('checkIn') || new Date().toISOString().split('T')[0])
        if (query.get('checkOut')) {
            setCheckout(query.get('checkOut'))
        }
    }, [query])

    useEffect(() => {

        


        const tommorow = new Date(checkin)
        tommorow.setDate(new Date(checkin).getDate() + 1)
        if (!query.get('checkOut') || new Date(checkout) - new Date(checkin) <= 0) {
            setCheckout(tommorow.toISOString().split('T')[0])
        }
    }, [checkin])

    return (
        <div className=" justify-start gap-y-1.5 items-stretch gap-x-2.5  flex-wrap my-5 hidden md:flex">
            <div className="p-2 px-4 shadow-md flex-shrink-0 rounded-full rounded-br-none pr-5 w-52  text-white bg-primary-blue flex flex-col justify-end relative">
                <p className="text-xs font-medium ">Airport Code</p>
                <input
                    value={iataCode}
                    onChange={handleAirportFetch}
                    placeholder="Airport Code"
                    // maxLength={4}
                    className="cursor-pointer  placeholder-gray-50 pr-2 flex-grow text-xs  bg-transparent outline-none"
                />
                {Boolean(airportlist.length) && (
                    <div className="absolute top-14 py-2  text-white left-0 w-max z-50  rounded bg-primary-blue">
                        {airportlist.map((curr, ind) => (
                            <p
                                key={ind}
                                onClick={() => {
                                    setIataCode(curr.iata)
                                    setAirportName(curr.name)
                                    setIataRefreshKey((e) => e + 1)
                                    setAirportList([])
                                    setAirportDetails({ ...curr })
                                }}
                                className="p-2 text-xs cursor-pointer hover:bg-opacity-40 hover:bg-gray-900"
                            >
                                {curr.iata}, {curr.name}
                            </p>
                        ))}
                    </div>
                )}
            </div>
            <div
                className="p-2 px-4 shadow-md flex-shrink-0 rounded-full rounded-br-none pr-10 w-52  text-white bg-primary-blue flex flex-col justify-end relative"
                onClick={() => setPropertyOption(!propertyOption)}
            >
                <p className="text-xs font-medium ">Booking Type</p>

                <div
                    className="cursor-pointer pr-2 flex-grow text-xs  bg-transparent outline-none"
                    onClick={() => setPropertyOption(!propertyOption)}
                >
                    {bookingType === '' ? 'Booking Type' : capitalizeEachWord(bookingType)}
                </div>
                {propertyOption && (
                    <div className="absolute top-[3.125rem] py-2 z-100 text-white left-0 right-0 rounded bg-primary-blue">
                        {bookingTypeList.map((list, index) => {
                            return (
                                <p
                                    onClick={() => {
                                        setBookingType(list)
                                        if (setGlobalBookingType) {
                                            setGlobalBookingType(list)
                                        }
                                        setPropertyOption(!propertyOption)
                                        if(iataCode)
                                        {
                                            window.location.href = `/property-listing/`+iataCode+`?iata=`+iataCode+`&airportName=`+airportDetails.name+`&bookingType=`+list;
                                        }
                                        else
                                        {
                                            window.location.href = `/property-listing?bookingType=`+list;
                                        }
                                        
                                    }}
                                    className="p-2 text-xs cursor-pointer hover:bg-opacity-40 hover:bg-gray-900"
                                    value={list}
                                    key={index}
                                >
                                    {capitalizeEachWord(list)}
                                </p>
                            )
                        })}
                    </div>
                )}
            </div>
            <div className="p-2 px-4 cursor-pointer shadow-md flex-shrink-0 mr-2 rounded-full rounded-br-none pr-10  text-gray-900  flex flex-col justify-end ">
                <p className="text-xs font-medium">Check-In</p>
                <input
                    value={checkin}
                    onChange={(e) => {
                        setCheckin(e.target.value)
                    }}
                    min={new Date().toISOString().split('T')[0]}
                    max={getFormattedDate(new Date(today.getFullYear(), today.getMonth() + 2, 0))}
                    type="date"
                    className="outline-none bg-transparent text-xs border-0 p-0 focus:ring-0 focus:border-0 "
                />
                {/* <p className="text-sm font-medium">TUE, 14 Sep 2021</p> */}
            </div>
            <div className="p-2 px-4 cursor-pointer  shadow-md flex-shrink-0 mr-2 rounded-full rounded-br-none pr-10  text-gray-900  flex flex-col justify-end ">
                <p className="text-xs font-medium">Check-Out</p>
                <input
                    value={checkout}
                    onChange={(e) => setCheckout(e.target.value)}
                    min={new Date(moment(new Date(checkin)).add(1, 'day')).toISOString().split('T')[0]}
                    max={getFormattedDate(new Date(today.getFullYear(), today.getMonth() + 2, 0))}
                    type="date"
                    className="outline-none bg-transparent text-xs border-0 p-0 focus:ring-0 focus:border-0 "
                />
            </div>
            <button
                onClick={handleSearchProperty}
                className="px-5 lg:my-auto my-2 w-44 p-2 rounded-full bg-primary-blue text-white font-medium   text-sm  "
            >
                SEARCH
            </button>
        </div>
    )
}

export const SearchTopBar = memo(_SearchTopBar)
